module.exports = __webpack_public_path__ + "static/media/ss_2_en.cd117716.jpg";